import { render } from "./Log.vue?vue&type=template&id=522b7ab7&scoped=true&ts=true"
import script from "./Log.vue?vue&type=script&lang=ts"
export * from "./Log.vue?vue&type=script&lang=ts"

import "./Log.vue?vue&type=style&index=0&id=522b7ab7&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522b7ab7"]])

export default __exports__